import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import Header from "common/Header";
import { TextArea } from "semantic-ui-react";
import css from "./ExchangeImpersonationModal.scss";
import Checkbox from "SF/Checkbox";
import Footer from "common/Footer";
import StyledButton from "common/StyledButton";

const ExchangeImpersonationModal = (props) => {
    Modal.setAppElement(document.getElementById("main-center"));
    return (
        <Modal isOpen={props.isOpen}
               onRequestClose={props.closeModal}
               overlayClassName={css['overlay']}
               className={css['modal']}>
            <Header closeModal={props.closeModal} />
            <div className={css['content']}>
                <h1>Exchange Opt-In Disclaimer</h1>
                <div id="review-terms" className={css['review']}>Please review the terms and conditions below:</div>
                <TextArea rows={5}
                          aria-labelledby="review-terms"
                          value={props.exchangeImpersonationDisclaimer} />
                <div className={css['opt-in-selection']}>
                    <Checkbox id="impersonation-opt-in-out"
                              ariaLabel=""
                              checked={props.exchangeImpersonationEnabled}
                              onChange={(checked) => props.onImpersonationOptInChange(checked)} />
                    <label htmlFor="impersonation-opt-in-out" className={css['terms']}>I agree.</label>
                </div>
            </div>
            <Footer
                primaryButton={
                    <StyledButton onClick={props.onImpersonationOptInSave}>
                        Save
                    </StyledButton>
                }
                secondaryButton={
                    <StyledButton asLink onClick={props.closeModal}>
                        Cancel
                    </StyledButton>
                }
            />
        </Modal>
    )
};

ExchangeImpersonationModal.propTypes = {
    exchangeImpersonationEnabled: PropTypes.bool,
    exchangeImpersonationDisclaimer: PropTypes.string,
    closeModal: PropTypes.func,
    isOpen: PropTypes.bool,
    onImpersonationOptInSave: PropTypes.func,
    onImpersonationOptInChange: PropTypes.func
};

export default ExchangeImpersonationModal;

